import { createSlice } from '@reduxjs/toolkit';
import { addNewCourse, editCourse, getAllActiveCourses, getAllCourses } from './courseService';

const initialState = {
  allCourses: {
    isCoursesLoading: null,
    isCoursesSuccess: null,
    coursesMessage: null,
    pageCount: 0,
    courses: [],
  },
  newCourse: {
    isCourseCreating: null,
    isCourseCreated: null,
    courseCreationMsg: null,
  },
  editedCourse: {
    isEditingCourse: null,
    isCourseEdited: null,
    courseEditedMsg: null
  }, 
  allActiveCourses: {
    isActiveCoursesLoading: null,
    isActiveCoursesSuccess: null,
    activeCoursesMessage: null,
    activeCourses: [],
  },
};

const coursesSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCourses.pending, (state) => {
        state.allCourses = {
          ...initialState.allCourses, // Reset to initial state
          isCoursesLoading: true,
          coursesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCourses.rejected, (state, action) => {
        state.allCourses = {
          ...initialState.allCourses,
          isCoursesLoading: false,
          isCoursesSuccess: false,
          coursesMessage: action.payload || 'Error occurred while fetching courses',
        };
      })

      // FULFILLED
      .addCase(getAllCourses.fulfilled, (state, action) => {
        state.allCourses = {
          ...initialState.allCourses,
          isCoursesLoading: false,
          isCoursesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          courses: action.payload || [],
        };
      });

    //Course creating
    builder
      .addCase(addNewCourse.pending, (state) => {
        state.newCourse = {
          ...initialState.newCourse, // Reset to initial state
          isCourseCreating: true,
          courseCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewCourse.rejected, (state, action) => {
        state.newCourse = {
          ...initialState.newCourse,
          isCourseCreating: false,
          isCourseCreated: false,
          courseCreationMsg: action.payload || 'Error occurred while creating the course.',
        };
      })

      // FULFILLED
      .addCase(addNewCourse.fulfilled, (state, action) => {
        state.newCourse = {
          ...initialState.newCourse,
          isCourseCreating: false,
          isCourseCreated: true,
          courseCreationMsg: action.payload || 'Successfully created the course.',
        };
      });

    //Course editing
    builder
      .addCase(editCourse.pending, (state) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: true,
          courseEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editCourse.rejected, (state, action) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: false,
          isCourseEdited: false,
          courseEditedMsg: action.payload || 'Error occurred while editing the course.',
        };
      })

      // FULFILLED
      .addCase(editCourse.fulfilled, (state, action) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: false,
          isCourseEdited: true,
          courseEditedMsg: action.payload || 'Successfully edited the course.',
        };
      });

      builder
      .addCase(getAllActiveCourses.pending, (state) => {
        state.allActiveCourses = {
          ...initialState.allActiveCourses, // Reset to initial state
          isActiveCoursesLoading: true,
          activeCoursesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllActiveCourses.rejected, (state, action) => {
        state.allActiveCourses = {
          ...initialState.allActiveCourses,
          isActiveCoursesLoading: false,
          isActiveCoursesSuccess: false,
          activeCoursesMessage: action.payload || 'Error occurred while fetching courses',
        };
      })

      // FULFILLED
      .addCase(getAllActiveCourses.fulfilled, (state, action) => {
        state.allActiveCourses = {
          ...initialState.allActiveCourses,
          isActiveCoursesLoading: false,
          isActiveCoursesSuccess: true,
          activeCourses: action.payload || [],
        };
      });
  },
});

export default coursesSlice.reducer;
